import React, { Fragment, useState } from "react";
import CommonSearchBar from "../common/CommonSearchBar";
import ClientDashboardCard from "./ClientDashboardCard";

const cardData = [
  { isLive: true, isCompleted: true },
  { isLive: false, isCompleted: true },
];
export default function ClientDashboardFulfilledRequirements() {
  const [values, setValues] = useState({
    searchStrFulfilledRequirements: "",
  });

  /*===========================================
              handler
  ===========================================*/

  const handleOnChange = (e) => {
    setValues({
      ...values,
      [e.target.name]: e.target.value,
    });
  };

  const handleOnClickSearchButton = (e) => {
    e.preventDefault();
    console.log(values.searchStrFulfilledRequirements);
  };

  /*===========================================
              main
  ===========================================*/
  return (
    <>
      <div className="mt-client-dash-req-tab-content">
        <CommonSearchBar
          name="searchStrFulfilledRequirements"
          value={values.searchStrFulfilledRequirements}
          onChange={handleOnChange}
          onClickSearchButton={handleOnClickSearchButton}
        />
        {cardData.map((data, index) => (
          <Fragment key={index}>
            <ClientDashboardCard cardData={data} />
          </Fragment>
        ))}
      </div>
    </>
  );
}
